module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/projector/projector.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/projector/projector.png
// module id = 602
// module chunks = 0